// Device presence: every session checks in (the server skips the write when nothing
// changed — V1_BEHAVIOR §3 /api/viewers); admins read the roster and can Kick a device,
// which forces that device back through the name gate (v1 contract).
import { signal } from '@preact/signals';
import { apiGet, apiPost } from '../lib/api';
import { techName } from './session';
import { toast } from './toast';

export interface Viewer {
  id: string;
  name: string;
  firstSeen: string;
  lastSeen: string;
  ua: string;
}

function deviceId(): string {
  let id = localStorage.getItem('deviceId') || '';
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('deviceId', id);
  }
  return id;
}

export const viewers = signal<Viewer[]>([]);

/** Boot/poll check-in. A kicked device acks (removing its row), drops its name, and the
 *  name gate reappears — exactly v1's "they re-enter their name next time". */
export async function checkIn(): Promise<void> {
  try {
    const res = await apiPost<{ ok: boolean; kicked: boolean }>('/api/viewers', {
      action: 'checkin',
      id: deviceId(),
      name: techName.value,
    });
    if (res.kicked) {
      await apiPost('/api/viewers', { action: 'ackKick', id: deviceId() }).catch(() => {});
      techName.value = '';
      localStorage.removeItem('techName');
      toast('The office reset this device — enter your name again.');
    }
  } catch {
    // presence is best-effort; never bother the user about it
  }
}

export async function fetchViewers(): Promise<void> {
  const res = await apiGet<{ viewers: Viewer[] }>('/api/viewers');
  viewers.value = res.viewers;
}

export async function kickViewer(id: string): Promise<void> {
  try {
    await apiPost('/api/viewers', { action: 'kick', id });
    viewers.value = viewers.value.filter((v) => v.id !== id);
  } catch {
    toast('Could not remove that device.');
  }
}
